
import { IPlanificationProfileScheduler } from '@/entity/planification/planification-profile-scheduler';
import { addDays } from 'date-fns';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { dateToString, IPhaseProfileByKey, IRetrieveKey, isEndDateAvailable, isStartDateAvailable, removeHour } from '../calendar-helper';
import { ConfigDeleted } from './scheduler-deleting-helper';

@Component({})
export default class SchedulerDeleting extends Vue {
    @Prop({ required: true }) deletedItem!: IPhaseProfileByKey[];
    @Prop({ required: true }) phases!: IPlanificationProfileScheduler[];
    
    objToDelete: ConfigDeleted[] = [];
    startDate: string | null = null;
    endDate: string | null = null;
    
    deleteConfirm() {
        this.$emit('confirmSave');
    }

    get deletedCount() {
        return this.objToDelete.reduce((acc, item) => acc + item.deleted.deleteCount, 0);
    }

    @Watch('startDate')
    @Watch('endDate')
    @Watch('deletedItem')
    onDateChanged() {
        if (this.startDate && !this.endDate) {
            this.endDate = this.startDate;
        }
        if (this.startDate && this.endDate) {
            this.objToDelete = this.calculatedDeletedItem();
            this.$emit('datesToDelete', this.objToDelete);
        }
    }

    isStartDateDisabled(_, date: Date) {
        return isStartDateAvailable(_, date, this.endDate);
    }

    isEndDateDisabled(_, date: Date) {
        return isEndDateAvailable(_, date, this.startDate);
    }

    // a refacto.
    isMatchKeyToScheduler(item: IPlanificationProfileScheduler, itemToCompare: IRetrieveKey): boolean {
        return (
            item.contractLineId === itemToCompare.contractLineId &&
            item.indexInPhase === itemToCompare.indexInPhase &&
            item.employeeId === itemToCompare.employeeId &&
            item.profileId === itemToCompare.profileId
        );
    }

    calculatedDeletedItem(): ConfigDeleted[] {
        if (this.deletedItem.length !== 1) {
            return [];
        }
        const deletedItem = this.deletedItem[0];

        const startDate: Date = removeHour(new Date(dateToString(this.startDate, 'yyyy-MM-dd', 0)));
        const endDate: Date = removeHour(new Date(dateToString(this.endDate, 'yyyy-MM-dd', 0)));
        const results: ConfigDeleted[] = [];

        const phase = this.phases.find((p) => this.isMatchKeyToScheduler(p, deletedItem.value));
        if (!phase) return [];

        const objToDelete: IPlanificationProfileScheduler[] =
            phase.parentPhaseId > 0
                ? [phase]
                : this.phases.filter(
                    (p) => p.parentPhaseId > 0 && p.contractLineId === deletedItem.value.contractLineId
                );
        objToDelete.forEach((phase) => {
            const obj = this.newConfigDeleted(deletedItem.key, phase);
            obj.deleted!.workoutDates = phase.planificationPhaseProfileWorkDays
                .filter((wd) => wd.date >= startDate && wd.date < addDays(endDate, 1))
                .map((wd) => ({ date: wd.date, formatted: dateToString(wd.date, 'dd/MM/yyyy') }));

            obj.deleted!.deleteCount = obj.deleted!.workoutDates.length;
            results.push(obj);
        });
        return results;
    }

    newConfigDeleted(key: string, phase: IPlanificationProfileScheduler) {
        return {
            key: key,
            phase: phase,
            deleted: {
                deleteCount: 0,
                workoutDates: []
            }
        } as ConfigDeleted;
    }
}
